const storageKey = 'dateTimeOverride';

export default function getDateTimeOverride() {
  return localStorage.getItem(storageKey);
}
